import script from "./user-card.vue?vue&type=script&setup=true&lang=js"
export * from "./user-card.vue?vue&type=script&setup=true&lang=js"

import "./user-card.vue?vue&type=style&index=0&id=b0d4f506&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0d4f506"]])

export default __exports__